/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./audit-overview-api/api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getImbalances = /* GraphQL */ `query GetImbalances(
  $material: String
  $size: String
  $month: String!
  $filter: ImbalanceFilter
  $isPersistent: Boolean
  $excludeColors: Boolean
  $statusFilter: String
  $nextToken: String
) {
  getImbalances(
    material: $material
    size: $size
    month: $month
    filter: $filter
    isPersistent: $isPersistent
    excludeColors: $excludeColors
    statusFilter: $statusFilter
    nextToken: $nextToken
  ) {
    items {
      material
      size
      quality
      coo
      wmsQty
      ciBondedQty
      ciNonBondedQty
      ciTotalQty
      imbalance
      persistentImbalance
      direction
      cleanStatus
      flowInformation
      __typename
    }
    nextToken
    totalCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetImbalancesQueryVariables,
  APITypes.GetImbalancesQuery
>;
